"use client";

// Root error boundary — catches errors in the root layout itself. It must
// render its own <html>/<body> because it replaces the root layout when it
// fires. Kept dependency-free (no shared components) so it renders even if the
// failure is in a shared provider.
import { useEffect } from "react";

export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		console.error("[global-error]", error);
	}, [error]);

	return (
		<html lang="en">
			<body
				style={{
					margin: 0,
					minHeight: "100vh",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					background: "#09090B",
					color: "#fafafa",
					fontFamily: "system-ui, sans-serif",
					padding: "24px",
				}}
			>
				<div style={{ textAlign: "center", maxWidth: 420 }}>
					<h1 style={{ fontSize: 20, fontWeight: 600, margin: "0 0 8px" }}>
						Something went wrong
					</h1>
					<p style={{ color: "#a1a1aa", fontSize: 14, margin: "0 0 20px" }}>
						The app hit an unexpected error. Please reload.
					</p>
					<button
						type="button"
						onClick={() => reset()}
						style={{
							background: "#0E6C5C",
							color: "#fff",
							border: "none",
							borderRadius: 10,
							padding: "10px 18px",
							fontSize: 14,
							fontWeight: 600,
							cursor: "pointer",
						}}
					>
						Reload
					</button>
				</div>
			</body>
		</html>
	);
}
